import { Grid } from "@mui/material";
import React from "react";
import LoadDocumentCmp from "../thumbnail/loadDocumentCmp";

const DocumentInfoComponent = (props: any) => {
  let lengthProps;
  if (
    props.data.length > 0 ||
    (props.showFooter != undefined && props.showFooter)
  ) {
    lengthProps = true;
  } else {
    lengthProps = false;
  }
  return (
    <>
      <div
        className="row "
        style={{ height: props.height ? props.height : "" }}
      >
        {lengthProps && props.data.length > 0 ? (
          props.data?.map((item: any) => (
            <div className=" col-2">
              <LoadDocumentCmp data={item} title={props.title} />
            </div>
          ))
        ) : props.showFooter != undefined && props.showFooter ? (
          <LoadDocumentCmp data={props.data} title={props.title} />
        ) : (
          <LoadDocumentCmp
            data={props.data}
            title={props.isGuarantor ? props.isGuarantor : ""}
          />
        )}
      </div>
    </>
  );
};

export default DocumentInfoComponent;
